var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{staticStyle:{"margin-bottom":"16px"},attrs:{"size":"small"}},[_c('a-space',{attrs:{"size":12}},[_c('label',[_vm._v("公式更新元素选项：")]),_vm._l((_vm.dictItemList),function(item){return _c('a-tag',{key:item.value},[_vm._v(_vm._s(item.text))])})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }